import { create } from 'zustand';
import { authenticateUser } from '../api/rewrites';

interface SessionState {
    sessionId: string | null;
    initializing: boolean;
    initializeSession: () => Promise<void>;
    refreshSession: () => Promise<void>;
}

export const useSessionStore = create<SessionState>((set, get) => ({
    sessionId: null,
    initializing: false,

    initializeSession: async () => {
        if (get().sessionId || get().initializing) return; // Prevent duplicate calls
        set({ initializing: true });

        try {
            const sessionId = await authenticateUser();
            set({ sessionId });
        } catch (error) {
        } finally {
            set({ initializing: false });
        }
    },

    refreshSession: async () => {
        set({ sessionId: null });
        await get().initializeSession();
    },
}));
